import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AyudaComponent } from './ayuda/ayuda.component';

const routes: Routes = [
  {
    path: '',
    title: 'Ayuda',
    component: AyudaComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AyudaRoutingModule {}
